/* Palestinian Elegance draft: preserve Shopify Inbox, but clear the menu.
 * Focal emits mobile-nav:open/close from <mobile-navigation>.
 * Shopify Inbox injects its own launcher (often #shopify-chat-dummy) after load.
 * A document-root state lets CSS hide even late-injected chat wrappers.
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var selector = "mobile-navigation#mobile-menu-drawer";
  var isMobile = window.matchMedia("(max-width: 900px)");
  var observed = null;
  var observer = null;
  var cartObserved = null;
  var cartObserver = null;

  function isOpen() {
    var drawer = document.querySelector(selector);
    return Boolean(isMobile.matches && drawer && drawer.hasAttribute("open"));
  }

  function cartIsOpen() {
    var drawer = document.querySelector("cart-drawer#mini-cart");
    return Boolean(drawer && drawer.hasAttribute("open"));
  }

  function sync() {
    if (isOpen()) root.setAttribute("data-pe-mobile-menu-open", "");
    else root.removeAttribute("data-pe-mobile-menu-open");
    if (cartIsOpen()) root.setAttribute("data-pe-cart-open", "");
    else root.removeAttribute("data-pe-cart-open");
  }

  function watchCart() {
    var drawer = document.querySelector("cart-drawer#mini-cart");
    if (drawer === cartObserved) { sync(); return; }
    if (cartObserver) cartObserver.disconnect();
    cartObserved = drawer;
    cartObserver = null;
    if (drawer && window.MutationObserver) {
      cartObserver = new MutationObserver(sync);
      cartObserver.observe(drawer, { attributes: true, attributeFilter: ["open"] });
    }
    sync();
  }

  function watchDrawer() {
    var drawer = document.querySelector(selector);
    if (drawer === observed) { sync(); return; }
    if (observer) observer.disconnect();
    observed = drawer;
    observer = null;
    if (drawer && window.MutationObserver) {
      observer = new MutationObserver(sync);
      observer.observe(drawer, { attributes: true, attributeFilter: ["open"] });
    }
    sync();
  }

  document.addEventListener("mobile-nav:open", function () {
    watchDrawer();
    sync();
  }, true);
  document.addEventListener("mobile-nav:close", sync, true);
  document.addEventListener("openable-element:open", function (event) {
    if (event.target && event.target.matches && event.target.matches(selector)) sync();
  }, true);
  document.addEventListener("openable-element:close", function (event) {
    if (event.target && event.target.matches && event.target.matches(selector)) sync();
  }, true);
  document.addEventListener("shopify:section:load", function () {
    watchDrawer();
    watchCart();
  });
  document.addEventListener("cart:updated", watchCart);
  document.addEventListener("cart:refresh", watchCart);
  document.addEventListener("openable-element:open", function (event) {
    if (event.target && event.target.matches && event.target.matches("cart-drawer#mini-cart")) watchCart();
  }, true);
  document.addEventListener("openable-element:close", function (event) {
    if (event.target && event.target.matches && event.target.matches("cart-drawer#mini-cart")) watchCart();
  }, true);
  if (isMobile.addEventListener) isMobile.addEventListener("change", sync);
  else if (isMobile.addListener) isMobile.addListener(sync);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { watchDrawer(); watchCart(); }, { once: true });
  } else {
    watchDrawer();
    watchCart();
  }
})();
